export default [
    {
        path: '/newpages',
        name: 'newpages',
        component: () => import('./index.vue'),
        meta: {
            title: '新页面'
        },
        children: [{
                path: 'ywzn',
                component: () => import('./ywzn/index.vue'),
                meta: {
                    title: '业务指南'
                }
            },
            {
                path: 'dygl',
                component: () => import('./dygl/index.vue'),
                meta: {
                    title: '党员管理'
                }
            },
            {
                path: 'serverhome',
                component: () => import('./serverhome/index.vue'),
                meta: {
                    title: '关于我们'
                }
            }
        ]
    }

]


// WEBPACK FOOTER //
// ./src/views/newpages/router.js